import { render } from "./TreeItem.vue?vue&type=template&id=f72ad29e&ts=true"
import script from "./TreeItem.ts?vue&type=script&lang=ts&external"
export * from "./TreeItem.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__